import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const EcButton = styled(Button)(`
    text-transform: none;
    font-weight:bold;
`);

export { EcButton };
